import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { Icon } from "@iconify/react";
import { Card, Spinner } from "react-bootstrap";
import Breadcrumb from "../components/Breadcrumb";
import swal from "sweetalert";

// Twilio & QuickBooks Constants
const QUICKBOOKS_CLIENT_ID = "YOUR_QUICKBOOKS_CLIENT_ID";
const QUICKBOOKS_REDIRECT_URI = "YOUR_REDIRECT_URL"; // Update with your redirect URL
const TWILIO_AUTH_TOKEN = "YOUR_TWILIO_AUTH_TOKEN"; // Use a real Twilio token in production

export default function IntegrationPage() {
  const [loading, setLoading] = useState(false);
  const [quickbooksConnected, setQuickbooksConnected] = useState(false);
  const [twilioConnected, setTwilioConnected] = useState(false);

  useEffect(() => {
    // Check if QuickBooks and Twilio are connected
    setQuickbooksConnected(localStorage.getItem("quickbooksConnected") === "true");
    setTwilioConnected(localStorage.getItem("twilioConnected") === "true");
  }, []);

  // QuickBooks OAuth Flow
  const handleQuickbooksConnect = () => {
    swal("Comming soon", "Quickbooks Integration feature is under development", "warning")
  };
  
  // Simulated Twilio Integration
  const handleTwilioConnect = () => {
    swal("Comming soon", "Twilio Integration feature is under development", "warning")
  };
  // handleTwilioConnect()
  return (
    <MasterLayout>
      <Breadcrumb title="Integration" />

      <div className="row" style={{ columnGap: 10 }}>
        {/* QuickBooks Card */}
        <div className="col-md-6 card p-3 shadow-sm rounded border h-100 bg-light">
          <div className="card-body">
            <div className="d-flex align-items-center gap-3">
              <span className="w-48 h-48 bg-primary text-white d-flex justify-content-center align-items-center rounded-circle">
                <Icon icon="simple-icons:quickbooks" width="30" height="30" />
              </span>
              <div>
                <span className="fw-medium text-secondary">QuickBooks</span>
                {quickbooksConnected ? (
                  <h6 className="text-success fw-semibold">Connected</h6>
                ) : (
                  <button style={{marginLeft: 80}} className="btn btn-primary" onClick={handleQuickbooksConnect}>
                    Connect
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Twilio Card */}
        <div className="col-md-6 mt-3 card p-3 shadow-sm rounded border h-100 bg-light">
          <div className="card-body">
            <div className="d-flex align-items-center gap-3">
              <span className="w-48 h-48 bg-danger text-white d-flex justify-content-end  rounded-circle">
                <Icon icon="simple-icons:twilio" width="30" height="30" />
              </span>
              <div >
                <span className="fw-medium text-secondary">Twilio (SMS)</span>
                {twilioConnected ? (
                  <h6 className="text-success fw-semibold">Connected</h6>
                ) : (
                  <button style={{marginLeft: 80}} className="btn btn-danger" onClick={handleTwilioConnect}>
                    Connect
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Loading Spinner */}
      {loading && (
        <div className="text-center mt-3">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
    </MasterLayout>
  );
}
